import * as React from "react";
const SvgSolidArrowDown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8 10.5L12.647 5.5H3.353L8 10.5Z", fill: "currentColor" }));
export default SvgSolidArrowDown;
